(() => {
  'use strict';

  const GLOBAL_KEY = 'TucoivaFloatingVideoV46';

  const LEGACY_KEYS = [
    'TucoivaFloatingVideoV45Dual',
    'TucoivaFloatingVideoV44Drag',
    'TucoivaFloatingVideoV43',
    'TucoivaFloatingVideoV42',
    'TucoivaFloatingVideoV4'
  ];

  /*
   * Shopify Theme Editor 热更新时，
   * 清理旧版本实例，避免重复监听。
   */
  LEGACY_KEYS.forEach((key) => {
    const legacy = window[key];

    if (
      !legacy ||
      legacy === window[GLOBAL_KEY]
    ) {
      return;
    }

    try {
      legacy.instances?.forEach?.((instance) => {
        instance?.destroy?.();
      });

      legacy.instances?.clear?.();

      delete window[key];
    } catch (error) {
      console.warn(
        '[Floating video] Legacy cleanup failed.',
        error
      );
    }
  });

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].scan(document);
    return;
  }

  const manager = {
    instances: new Map(),
    listenersInstalled: false,

    numberOr(value, fallback) {
      const number = Number(value);

      return Number.isFinite(number)
        ? number
        : fallback;
    },

    boolOr(value, fallback) {
      if (typeof value === 'boolean') {
        return value;
      }

      if (value === 'true') {
        return true;
      }

      if (value === 'false') {
        return false;
      }

      return fallback;
    },

    parseConfig(root) {
      const node =
        root.querySelector('.fv-config');

      if (!node) {
        return null;
      }

      try {
        return JSON.parse(
          node.textContent.trim()
        );
      } catch (error) {
        console.error(
          '[Floating video] Invalid configuration.',
          error
        );

        return null;
      }
    },

    normalizeRatio(value) {
      const ratio =
        String(value || '9-16')
          .trim()
          .toLowerCase()
          .replace(/\s+/g, '');

      const ratios = {
        '916': {
          className: 'fv-ratio-9-16',
          css: '9 / 16'
        },

        '9-16': {
          className: 'fv-ratio-9-16',
          css: '9 / 16'
        },

        '9:16': {
          className: 'fv-ratio-9-16',
          css: '9 / 16'
        },

        '45': {
          className: 'fv-ratio-4-5',
          css: '4 / 5'
        },

        '4-5': {
          className: 'fv-ratio-4-5',
          css: '4 / 5'
        },

        '4:5': {
          className: 'fv-ratio-4-5',
          css: '4 / 5'
        },

        '11': {
          className: 'fv-ratio-1-1',
          css: '1 / 1'
        },

        '1-1': {
          className: 'fv-ratio-1-1',
          css: '1 / 1'
        },

        '1:1': {
          className: 'fv-ratio-1-1',
          css: '1 / 1'
        },

        '169': {
          className: 'fv-ratio-16-9',
          css: '16 / 9'
        },

        '16-9': {
          className: 'fv-ratio-16-9',
          css: '16 / 9'
        },

        '16:9': {
          className: 'fv-ratio-16-9',
          css: '16 / 9'
        }
      };

      return (
        ratios[ratio] ||
        ratios['9-16']
      );
    },

    normalizeRatioKey(value) {
      const normalized =
        String(value || '9-16')
          .trim()
          .toLowerCase()
          .replace(/\s+/g, '');

      const keys = {
        '916': '9-16',
        '9-16': '9-16',
        '9:16': '9-16',

        '45': '4-5',
        '4-5': '4-5',
        '4:5': '4-5',

        '11': '1-1',
        '1-1': '1-1',
        '1:1': '1-1',

        '169': '16-9',
        '16-9': '16-9',
        '16:9': '16-9'
      };

      return (
        keys[normalized] ||
        '9-16'
      );
    },

    getPresetWidths(
      desktopPreset,
      mobilePreset,
      ratioValue
    ) {
      const ratio =
        this.normalizeRatioKey(
          ratioValue
        );

      const desktop = {
        small: {
          '9-16': 125,
          '4-5': 145,
          '1-1': 165,
          '16-9': 210
        },

        medium: {
          '9-16': 145,
          '4-5': 165,
          '1-1': 185,
          '16-9': 235
        },

        large: {
          '9-16': 165,
          '4-5': 190,
          '1-1': 210,
          '16-9': 270
        }
      };

      const mobile = {
        small: {
          '9-16': 88,
          '4-5': 100,
          '1-1': 112,
          '16-9': 142
        },

        medium: {
          '9-16': 102,
          '4-5': 116,
          '1-1': 128,
          '16-9': 164
        },

        large: {
          '9-16': 116,
          '4-5': 132,
          '1-1': 144,
          '16-9': 184
        }
      };

      const safeDesktopPreset =
        [
          'small',
          'medium',
          'large'
        ].includes(desktopPreset)
          ? desktopPreset
          : 'medium';

      const safeMobilePreset =
        [
          'small',
          'medium',
          'large'
        ].includes(mobilePreset)
          ? mobilePreset
          : 'medium';

      return {
        desktop:
          desktop[
            safeDesktopPreset
          ][ratio],

        mobile:
          mobile[
            safeMobilePreset
          ][ratio]
      };
    },

    normalizeConfig(raw) {
      return {
        ...raw,

        sectionId:
          String(
            raw.sectionId || ''
          ).trim(),

        videoUrl:
          String(
            raw.videoUrl || ''
          ).trim(),

        poster:
          String(
            raw.poster || ''
          ).trim(),

        youtubeUrl:
          String(
            raw.youtubeUrl || ''
          ).trim(),

        ratio:
          String(
            raw.ratio || '9-16'
          ).trim(),

        triggerMode:
          raw.triggerMode === 'scroll'
            ? 'scroll'
            : 'smart',

        customHeroSelector:
          String(
            raw.customHeroSelector || ''
          ).trim(),

        heroVisiblePercent:
          Math.max(
            0,
            Math.min(
              50,
              this.numberOr(
                raw.heroVisiblePercent,
                15
              )
            )
          ),

        desktopShowAfter:
          Math.max(
            0,
            this.numberOr(
              raw.desktopShowAfter,
              520
            )
          ),

        mobileShowAfter:
          Math.max(
            0,
            this.numberOr(
              raw.mobileShowAfter,
              420
            )
          ),

        delay:
          Math.max(
            0,
            this.numberOr(
              raw.delay,
              200
            )
          ),

        hideWhenBackAtTop:
          this.boolOr(
            raw.hideWhenBackAtTop,
            true
          ),

        rememberDismiss:
          this.boolOr(
            raw.rememberDismiss,
            true
          ),

        forceShow:
          this.boolOr(
            raw.forceShow,
            false
          ),

        desktopSizePreset:
          [
            'small',
            'medium',
            'large'
          ].includes(
            raw.desktopSizePreset
          )
            ? raw.desktopSizePreset
            : 'medium',

        mobileSizePreset:
          [
            'small',
            'medium',
            'large'
          ].includes(
            raw.mobileSizePreset
          )
            ? raw.mobileSizePreset
            : 'medium',

        desktopVerticalPercent:
          Math.max(
            0,
            Math.min(
              100,
              this.numberOr(
                raw.desktopVerticalPercent,
                25
              )
            )
          ),

        mobileVerticalPercent:
          Math.max(
            0,
            Math.min(
              100,
              this.numberOr(
                raw.mobileVerticalPercent,
                25
              )
            )
          ),

        desktopHorizontalPosition:
          [
            'left',
            'center',
            'right'
          ].includes(
            raw.desktopHorizontalPosition
          )
            ? raw.desktopHorizontalPosition
            : 'right',

        desktopSideOffset:
          Math.max(
            0,
            this.numberOr(
              raw.desktopSideOffset,
              24
            )
          ),

        mobileHorizontalPosition:
          [
            'left',
            'center',
            'right'
          ].includes(
            raw.mobileHorizontalPosition
          )
            ? raw.mobileHorizontalPosition
            : 'right',

        mobileSideOffset:
          Math.max(
            0,
            this.numberOr(
              raw.mobileSideOffset,
              12
            )
          ),

        borderRadius:
          Math.max(
            0,
            this.numberOr(
              raw.borderRadius,
              14
            )
          ),

        showShadow:
          this.boolOr(
            raw.showShadow,
            true
          ),

        showBadge:
          this.boolOr(
            raw.showBadge,
            true
          ),

        badgeText:
          String(
            raw.badgeText || 'Video'
          ).trim()
      };
    },

    getYouTubeId(url) {
      if (!url) {
        return '';
      }

      try {
        const parsed =
          new URL(
            url,
            window.location.origin
          );

        const host =
          parsed.hostname
            .replace(/^www\./, '')
            .toLowerCase();

        if (
          host === 'youtu.be'
        ) {
          return (
            parsed.pathname
              .split('/')
              .filter(Boolean)[0] ||
            ''
          );
        }

        if (
          parsed.pathname
            .startsWith('/shorts/')
        ) {
          return (
            parsed.pathname
              .split('/')[2] ||
            ''
          );
        }

        if (
          parsed.pathname
            .startsWith('/embed/')
        ) {
          return (
            parsed.pathname
              .split('/')[2] ||
            ''
          );
        }

        return (
          parsed.searchParams
            .get('v') ||
          ''
        );
      } catch (error) {
        return '';
      }
    },

    createFloatingVideo(config) {
      const video =
        document.createElement(
          'video'
        );

      video.src =
        config.videoUrl;

      video.preload =
        'auto';

      video.loop =
        true;

      video.autoplay =
        true;

      video.muted =
        true;

      video.defaultMuted =
        true;

      video.playsInline =
        true;

      video.controls =
        false;

      video.setAttribute(
        'muted',
        ''
      );

      video.setAttribute(
        'autoplay',
        ''
      );

      video.setAttribute(
        'loop',
        ''
      );

      video.setAttribute(
        'playsinline',
        ''
      );

      video.setAttribute(
        'webkit-playsinline',
        ''
      );

      if (
        config.poster
      ) {
        video.poster =
          config.poster;
      }

      return video;
    },

    createShopifyModalVideo(
      config
    ) {
      const video =
        document.createElement(
          'video'
        );

      video.src =
        config.videoUrl;

      video.preload =
        'metadata';

      video.loop =
        false;

      video.autoplay =
        true;

      video.muted =
        false;

      video.defaultMuted =
        false;

      video.volume =
        1;

      video.playsInline =
        true;

      video.controls =
        true;

      video.setAttribute(
        'playsinline',
        ''
      );

      video.setAttribute(
        'webkit-playsinline',
        ''
      );

      if (
        config.poster
      ) {
        video.poster =
          config.poster;
      }

      return video;
    },

    createYouTubeModal(
      url
    ) {
      const videoId =
        this.getYouTubeId(
          url
        );

      if (!videoId) {
        return null;
      }

      const iframe =
        document.createElement(
          'iframe'
        );

      const params =
        new URLSearchParams({
          autoplay: '1',
          controls: '1',
          mute: '0',
          playsinline: '1',
          rel: '0',
          enablejsapi: '1',
          fs: '1'
        });

      if (
        window.location.origin &&
        window.location.origin !==
          'null'
      ) {
        params.set(
          'origin',
          window.location.origin
        );
      }

      iframe.src =
        `https://www.youtube.com/embed/${encodeURIComponent(
          videoId
        )}?${params.toString()}`;

      iframe.title =
        'Product video';

      iframe.allow =
        'autoplay; encrypted-media; picture-in-picture; fullscreen';

      iframe.allowFullscreen =
        true;

      iframe.setAttribute(
        'playsinline',
        ''
      );

      return iframe;
    },

    youtubeCommand(
      iframe,
      command
    ) {
      if (
        !(
          iframe instanceof
          HTMLIFrameElement
        )
      ) {
        return;
      }

      try {
        iframe.contentWindow
          ?.postMessage(
            JSON.stringify({
              event: 'command',
              func: command,
              args: []
            }),
            '*'
          );
      } catch (error) {
        /*
         * iframe 可能还没有加载完成。
         */
      }
    },

    scan(root = document) {
      root
        .querySelectorAll?.(
          '[data-fv-root]'
        )
        .forEach(
          (source) => {
            this.init(
              source
            );
          }
        );
    },

    init(root) {
      if (
        !root ||
        !root.matches(
          '[data-fv-root]'
        )
      ) {
        return;
      }

      const sectionId =
        String(
          root.dataset.sectionId ||
          ''
        ).trim();

      if (!sectionId) {
        return;
      }

      const previous =
        this.instances.get(
          sectionId
        );

      if (previous) {
        previous.destroy();
      }

      const rawConfig =
        this.parseConfig(
          root
        );

      /*
       * Shopify Video 是必须的。
       */
      if (
        !rawConfig ||
        !rawConfig.videoUrl
      ) {
        this.instances.delete(
          sectionId
        );

        return;
      }

      const config =
        this.normalizeConfig(
          rawConfig
        );

      const instance =
        this.createInstance(
          root,
          config
        );

      this.instances.set(
        sectionId,
        instance
      );

      instance.init();
    },

    createInstance(
      root,
      config
    ) {
      const manager = this;

      return {
        root,
        config,

        sectionId:
          config.sectionId,

        floating: null,
        floatingMedia: null,
        openButton: null,
        closeButton: null,

        modal: null,
        modalMedia: null,
        modalCloseButton: null,
        modalUsesYouTube: false,

        lastFocusedElement: null,
        onModalKeydownBound: null,

        hero: null,
        heroObserver: null,
        heroLookupTimer: null,
        heroLookupAttempts: 0,
        heroSearchExhausted: false,

        pageScrollElement: null,

        dismissed: false,
        everRevealed: false,
        isVisible: false,

        frameRequested: false,
        revealTimer: null,
        animationFrame: null,

        /*
         * Drag
         */
        dragActive: false,
        dragMoved: false,
        dragPointerId: null,

        dragStartX: 0,
        dragStartY: 0,

        dragStartLeft: 0,
        dragStartTop: 0,

        dragThreshold: 6,

        suppressOpenClick: false,
        suppressOpenClickTimer: null,

        /*
         * 用户拖动位置
         */
        hasUserPosition: false,
        userPosition: null,
        positionMode: null,

        init() {
          this.dismissed =
            this.readDismissedState();

          this.onAnyScrollBound =
            this.onAnyScroll.bind(
              this
            );

          this.onViewportChangeBound =
            this.onViewportChange.bind(
              this
            );

          window.addEventListener(
            'scroll',
            this.onAnyScrollBound,
            {
              passive: true
            }
          );

          document.addEventListener(
            'scroll',
            this.onAnyScrollBound,
            {
              passive: true,
              capture: true
            }
          );

          window.addEventListener(
            'resize',
            this.onViewportChangeBound,
            {
              passive: true
            }
          );

          window.addEventListener(
            'orientationchange',
            this.onViewportChangeBound,
            {
              passive: true
            }
          );

          window.addEventListener(
            'load',
            this.onViewportChangeBound,
            {
              once: true
            }
          );

          this.removeOrphanArtifacts();

          this.resolvePageScrollElement(
            true
          );

          this.resolveHero();

          this.requestUpdate();
        },

        destroy() {
          window.removeEventListener(
            'scroll',
            this.onAnyScrollBound
          );

          document.removeEventListener(
            'scroll',
            this.onAnyScrollBound,
            true
          );

          window.removeEventListener(
            'resize',
            this.onViewportChangeBound
          );

          window.removeEventListener(
            'orientationchange',
            this.onViewportChangeBound
          );

          this.cancelReveal();

          if (
            this.animationFrame
          ) {
            window.cancelAnimationFrame(
              this.animationFrame
            );

            this.animationFrame =
              null;
          }

          if (
            this.heroLookupTimer
          ) {
            window.clearTimeout(
              this.heroLookupTimer
            );

            this.heroLookupTimer =
              null;
          }

          if (
            this.heroObserver
          ) {
            this.heroObserver
              .disconnect();

            this.heroObserver =
              null;
          }

          if (
            this.suppressOpenClickTimer
          ) {
            window.clearTimeout(
              this.suppressOpenClickTimer
            );

            this.suppressOpenClickTimer =
              null;
          }

          this.closeModal(
            true
          );

          if (
            this.floating
          ) {
            this.floating.remove();
          }

          this.floating =
            null;

          this.floatingMedia =
            null;

          this.openButton =
            null;

          this.closeButton =
            null;
        },

        removeOrphanArtifacts() {
          document
            .querySelectorAll(
              `[data-fv-instance="${this.sectionId}"]`
            )
            .forEach(
              (element) => {
                element.remove();
              }
            );

          document
            .querySelectorAll(
              `[data-fv-modal="${this.sectionId}"]`
            )
            .forEach(
              (element) => {
                element.remove();
              }
            );
        },

        /*
         * ================================
         * Dismiss
         * ================================
         */

        dismissKey() {
          return (
            `fv-dismissed:` +
            `${window.location.pathname}:` +
            `${this.sectionId}`
          );
        },

        readDismissedState() {
          if (
            !this.config
              .rememberDismiss
          ) {
            return false;
          }

          if (
            window.Shopify &&
            window.Shopify.designMode
          ) {
            return false;
          }

          try {
            return (
              window.sessionStorage
                .getItem(
                  this.dismissKey()
                ) === '1'
            );
          } catch (error) {
            return false;
          }
        },

        saveDismissedState() {
          if (
            !this.config
              .rememberDismiss
          ) {
            return;
          }

          if (
            window.Shopify &&
            window.Shopify.designMode
          ) {
            return;
          }

          try {
            window.sessionStorage
              .setItem(
                this.dismissKey(),
                '1'
              );
          } catch (error) {
            /*
             * Ignore.
             */
          }
        },

        /*
         * ================================
         * Drag position storage
         * ================================
         */

        positionStorageMode() {
          return this.isMobile()
            ? 'mobile'
            : 'desktop';
        },

        positionKey(
          mode =
            this.positionStorageMode()
        ) {
          return (
            `fv-position:` +
            `${window.location.pathname}:` +
            `${this.sectionId}:` +
            `${mode}`
          );
        },

        readUserPosition(
          mode =
            this.positionStorageMode()
        ) {
          /*
           * Theme Editor 不读取保存位置，
           * 方便调整后台默认位置。
           */
          if (
            window.Shopify &&
            window.Shopify.designMode
          ) {
            return null;
          }

          try {
            const raw =
              window.sessionStorage
                .getItem(
                  this.positionKey(
                    mode
                  )
                );

            if (!raw) {
              return null;
            }

            const parsed =
              JSON.parse(raw);

            const left =
              Number(
                parsed?.left
              );

            const top =
              Number(
                parsed?.top
              );

            if (
              !Number.isFinite(
                left
              ) ||
              !Number.isFinite(
                top
              )
            ) {
              return null;
            }

            return {
              left,
              top
            };
          } catch (error) {
            return null;
          }
        },

        saveUserPosition() {
          if (
            !this.hasUserPosition ||
            !this.userPosition
          ) {
            return;
          }

          if (
            window.Shopify &&
            window.Shopify.designMode
          ) {
            return;
          }

          try {
            window.sessionStorage
              .setItem(
                this.positionKey(
                  this.positionMode ||
                  this.positionStorageMode()
                ),

                JSON.stringify({
                  left:
                    Math.round(
                      this.userPosition
                        .left
                    ),

                  top:
                    Math.round(
                      this.userPosition
                        .top
                    )
                })
              );
          } catch (error) {
            /*
             * Ignore.
             */
          }
        },

        restoreConfiguredPositionClasses() {
          if (
            !this.floating
          ) {
            return;
          }

          this.floating
            .classList
            .remove(
              'fv-position-left',
              'fv-position-center',
              'fv-position-right',
              'fv-mobile-position-left',
              'fv-mobile-position-center',
              'fv-mobile-position-right'
            );

          this.floating
            .classList
            .add(
              `fv-position-${this.config.desktopHorizontalPosition}`,
              `fv-mobile-position-${this.config.mobileHorizontalPosition}`
            );
        },

        removeConfiguredPositionClasses() {
          if (
            !this.floating
          ) {
            return;
          }

          this.floating
            .classList
            .remove(
              'fv-position-left',
              'fv-position-center',
              'fv-position-right',
              'fv-mobile-position-left',
              'fv-mobile-position-center',
              'fv-mobile-position-right'
            );
        },

        clearUserPositionStyles() {
          if (
            !this.floating
          ) {
            return;
          }

          [
            'left',
            'top',
            'right',
            'bottom'
          ].forEach(
            (property) => {
              this.floating
                .style
                .removeProperty(
                  property
                );
            }
          );

          this.floating
            .classList
            .remove(
              'fv-user-position',
              'is-dragging'
            );

          this.restoreConfiguredPositionClasses();
        },

        getFloatingBounds() {
          if (
            !this.floating
          ) {
            return null;
          }

          const rect =
            this.floating
              .getBoundingClientRect();

          const viewportWidth =
            Math.max(
              1,

              window.innerWidth ||

              document.documentElement
                .clientWidth ||

              1
            );

          const viewportHeight =
            Math.max(
              1,

              window.innerHeight ||

              document.documentElement
                .clientHeight ||

              1
            );

          const gap = 8;

          return {
            minLeft: gap,
            minTop: gap,

            maxLeft:
              Math.max(
                gap,

                viewportWidth -
                rect.width -
                gap
              ),

            maxTop:
              Math.max(
                gap,

                viewportHeight -
                rect.height -
                gap
              )
          };
        },

        clampFloatingPosition(
          left,
          top
        ) {
          const bounds =
            this.getFloatingBounds();

          if (!bounds) {
            return {
              left: 0,
              top: 0
            };
          }

          return {
            left:
              Math.min(
                bounds.maxLeft,

                Math.max(
                  bounds.minLeft,
                  Number(left) || 0
                )
              ),

            top:
              Math.min(
                bounds.maxTop,

                Math.max(
                  bounds.minTop,
                  Number(top) || 0
                )
              )
          };
        },

        applyUserPosition(
          left,
          top,
          persist = false
        ) {
          if (
            !this.floating ||
            !this.floating.isConnected
          ) {
            return;
          }

          const next =
            this.clampFloatingPosition(
              left,
              top
            );

          this.hasUserPosition =
            true;

          this.userPosition =
            next;

          this.positionMode =
            this.positionStorageMode();

          this.removeConfiguredPositionClasses();

          this.floating
            .classList
            .add(
              'fv-user-position'
            );

          this.floating
            .style
            .setProperty(
              'left',
              `${Math.round(
                next.left
              )}px`,
              'important'
            );

          this.floating
            .style
            .setProperty(
              'top',
              `${Math.round(
                next.top
              )}px`,
              'important'
            );

          this.floating
            .style
            .setProperty(
              'right',
              'auto',
              'important'
            );

          this.floating
            .style
            .setProperty(
              'bottom',
              'auto',
              'important'
            );

          if (persist) {
            this.saveUserPosition();
          }
        },

        restoreUserPositionForCurrentMode() {
          const mode =
            this.positionStorageMode();

          const saved =
            this.readUserPosition(
              mode
            );

          this.positionMode =
            mode;

          if (!saved) {
            this.hasUserPosition =
              false;

            this.userPosition =
              null;

            this.clearUserPositionStyles();

            return false;
          }

          this.applyUserPosition(
            saved.left,
            saved.top,
            false
          );

          return true;
        },

        /*
         * ================================
         * Drag events
         * ================================
         */

        onFloatingPointerDown(
          event
        ) {
          if (
            !this.floating ||
            !this.isVisible
          ) {
            return;
          }

          if (
            event.pointerType ===
              'mouse' &&
            event.button !== 0
          ) {
            return;
          }

          /*
           * × 按钮不进入拖动。
           */
          if (
            event.target
              ?.closest?.(
                '.fv-close'
              )
          ) {
            return;
          }

          const rect =
            this.floating
              .getBoundingClientRect();

          this.dragActive =
            true;

          this.dragMoved =
            false;

          this.dragPointerId =
            event.pointerId;

          this.dragStartX =
            event.clientX;

          this.dragStartY =
            event.clientY;

          this.dragStartLeft =
            rect.left;

          this.dragStartTop =
            rect.top;

          /*
           * 注意：
           * pointerdown 不 capture。
           *
           * 普通点击需要正常落到
           * .fv-open-button。
           */
        },

        onFloatingPointerMove(
          event
        ) {
          if (
            !this.dragActive ||
            event.pointerId !==
              this.dragPointerId
          ) {
            return;
          }

          const deltaX =
            event.clientX -
            this.dragStartX;

          const deltaY =
            event.clientY -
            this.dragStartY;

          if (
            !this.dragMoved
          ) {
            const distance =
              Math.hypot(
                deltaX,
                deltaY
              );

            /*
             * 6px 以内视为点击，
             * 不视为拖动。
             */
            if (
              distance <
              this.dragThreshold
            ) {
              return;
            }

            this.dragMoved =
              true;

            this.floating
              ?.classList
              .add(
                'is-dragging'
              );

            /*
             * 真正开始拖动以后
             * 才 capture pointer。
             */
            try {
              this.floating
                .setPointerCapture(
                  event.pointerId
                );
            } catch (error) {
              /*
               * Ignore.
               */
            }

            /*
             * 把当前默认 CSS 位置
             * 转成 left/top。
             */
            this.applyUserPosition(
              this.dragStartLeft,
              this.dragStartTop,
              false
            );
          }

          event.preventDefault();

          this.applyUserPosition(
            this.dragStartLeft +
              deltaX,

            this.dragStartTop +
              deltaY,

            false
          );
        },

        finishFloatingDrag(
          event
        ) {
          if (
            !this.dragActive ||
            event.pointerId !==
              this.dragPointerId
          ) {
            return;
          }

          const moved =
            this.dragMoved;

          this.dragActive =
            false;

          this.dragMoved =
            false;

          this.dragPointerId =
            null;

          this.floating
            ?.classList
            .remove(
              'is-dragging'
            );

          try {
            if (
              this.floating
                ?.hasPointerCapture?.(
                  event.pointerId
                )
            ) {
              this.floating
                .releasePointerCapture(
                  event.pointerId
                );
            }
          } catch (error) {
            /*
             * Ignore.
             */
          }

          /*
           * 没有超过拖动阈值：
           * 继续让 click 正常发生。
           */
          if (!moved) {
            return;
          }

          event.preventDefault();

          this.saveUserPosition();

          /*
           * 拖完以后浏览器可能补一次 click，
           * 防止立即打开大视频。
           */
          this.suppressOpenClick =
            true;

          if (
            this.suppressOpenClickTimer
          ) {
            window.clearTimeout(
              this.suppressOpenClickTimer
            );
          }

          this.suppressOpenClickTimer =
            window.setTimeout(
              () => {
                this.suppressOpenClick =
                  false;

                this.suppressOpenClickTimer =
                  null;
              },
              350
            );
        },

        installFloatingDrag(
          floating
        ) {
          floating.addEventListener(
            'pointerdown',
            (event) => {
              this.onFloatingPointerDown(
                event
              );
            }
          );

          floating.addEventListener(
            'pointermove',
            (event) => {
              this.onFloatingPointerMove(
                event
              );
            }
          );

          floating.addEventListener(
            'pointerup',
            (event) => {
              this.finishFloatingDrag(
                event
              );
            }
          );

          floating.addEventListener(
            'pointercancel',
            (event) => {
              this.finishFloatingDrag(
                event
              );
            }
          );

          floating.addEventListener(
            'dragstart',
            (event) => {
              event.preventDefault();
            }
          );
        },

        /*
         * ================================
         * Page scrolling
         * ================================
         */

        getDocumentScrollTop() {
          return Math.max(
            Number(
              window.pageYOffset || 0
            ),

            Number(
              document.scrollingElement
                ?.scrollTop || 0
            ),

            Number(
              document.documentElement
                ?.scrollTop || 0
            ),

            Number(
              document.body
                ?.scrollTop || 0
            )
          );
        },

        isScrollablePageElement(
          element
        ) {
          if (
            !(
              element instanceof
              Element
            )
          ) {
            return false;
          }

          const style =
            window.getComputedStyle(
              element
            );

          const overflowY =
            String(
              style.overflowY || ''
            ).toLowerCase();

          if (
            !/(auto|scroll|overlay)/
              .test(
                overflowY
              )
          ) {
            return false;
          }

          const clientHeight =
            Number(
              element.clientHeight ||
              0
            );

          const scrollHeight =
            Number(
              element.scrollHeight ||
              0
            );

          const viewportHeight =
            Math.max(
              1,

              window.innerHeight ||

              document.documentElement
                .clientHeight ||

              1
            );

          return (
            scrollHeight >
              clientHeight + 120 &&

            clientHeight >=
              Math.min(
                420,
                viewportHeight *
                  0.55
              )
          );
        },

        getScrollableAncestor(
          element
        ) {
          let current =
            element?.parentElement ||
            null;

          while (
            current &&

            current !==
              document.body &&

            current !==
              document.documentElement
          ) {
            if (
              this.isScrollablePageElement(
                current
              )
            ) {
              return current;
            }

            current =
              current.parentElement;
          }

          return null;
        },

        findPageScrollElement() {
          return (
            this.getScrollableAncestor(
              this.hero
            ) ||

            this.getScrollableAncestor(
              this.root
            ) ||

            null
          );
        },

        resolvePageScrollElement(
          force = false
        ) {
          if (
            !force &&

            this.pageScrollElement &&

            this.pageScrollElement
              .isConnected
          ) {
            return (
              this.pageScrollElement
            );
          }

          this.pageScrollElement =
            this.findPageScrollElement();

          return (
            this.pageScrollElement
          );
        },

        isPageScrollEvent(
          event
        ) {
          const target =
            event?.target;

          if (
            !target ||

            target === window ||

            target === document ||

            target ===
              document.documentElement ||

            target ===
              document.body ||

            target ===
              document.scrollingElement
          ) {
            return true;
          }

          return Boolean(
            this.pageScrollElement &&

            target ===
              this.pageScrollElement
          );
        },

        onAnyScroll(
          event
        ) {
          if (
            !this.isPageScrollEvent(
              event
            )
          ) {
            return;
          }

          this.requestUpdate();
        },

        onViewportChange() {
          this.resolvePageScrollElement(
            true
          );

          if (
            !this.hero ||
            !this.hero.isConnected
          ) {
            this.resolveHero(
              true
            );
          }

          window.requestAnimationFrame(
            () => {
              this.updateFloatingGeometry();
            }
          );

          this.requestUpdate();
        },

        getCurrentScrollTop() {
          const documentTop =
            this.getDocumentScrollTop();

          if (
            this.pageScrollElement &&

            this.pageScrollElement
              .isConnected
          ) {
            return Math.max(
              documentTop,

              Number(
                this.pageScrollElement
                  .scrollTop || 0
              )
            );
          }

          return documentTop;
        },

        isMobile() {
          return window
            .matchMedia(
              '(max-width: 749px)'
            )
            .matches;
        },

        getFallbackThreshold() {
          return this.isMobile()
            ? this.config
                .mobileShowAfter
            : this.config
                .desktopShowAfter;
        },

        /*
         * ================================
         * Hero detection
         * ================================
         */

        safeQuerySelector(
          selector
        ) {
          if (!selector) {
            return null;
          }

          try {
            return (
              document.querySelector(
                selector
              )
            );
          } catch (error) {
            console.warn(
              '[Floating video] Invalid hero selector:',
              selector
            );

            return null;
          }
        },

        heroCandidates() {
          const selectors = [
            '[data-product-media-gallery]',
            '[data-product-gallery]',
            '[data-product-media-wrapper]',
            '.product__media-wrapper',
            '.product__media-list',
            '.product-media-wrapper',
            '.product-media-gallery',
            '.product-gallery',
            '.product-gallery__media-list',
            '.product-gallery__carousel',
            '.product-gallery__media',
            '.product__media',
            '[data-product-media]'
          ];

          const candidates =
            [];

          const seen =
            new Set();

          const viewportWidth =
            Math.max(
              1,

              window.innerWidth ||

              document.documentElement
                .clientWidth ||

              1
            );

          const viewportHeight =
            Math.max(
              1,

              window.innerHeight ||

              document.documentElement
                .clientHeight ||

              1
            );

          selectors.forEach(
            (
              selector,
              selectorIndex
            ) => {
              document
                .querySelectorAll(
                  selector
                )
                .forEach(
                  (element) => {
                    if (
                      seen.has(
                        element
                      )
                    ) {
                      return;
                    }

                    seen.add(
                      element
                    );

                    const rect =
                      element
                        .getBoundingClientRect();

                    const width =
                      Math.max(
                        0,
                        rect.width
                      );

                    const height =
                      Math.max(
                        0,
                        rect.height
                      );

                    if (
                      width < 220 ||
                      height < 220
                    ) {
                      return;
                    }

                    const style =
                      window
                        .getComputedStyle(
                          element
                        );

                    if (
                      style.display ===
                        'none' ||

                      style.visibility ===
                        'hidden' ||

                      Number(
                        style.opacity || 1
                      ) === 0
                    ) {
                      return;
                    }

                    const documentTop =
                      rect.top +
                      this.getDocumentScrollTop();

                    if (
                      documentTop >
                      viewportHeight *
                        3.5
                    ) {
                      return;
                    }

                    const area =
                      Math.min(
                        width,
                        viewportWidth
                      ) *
                      Math.min(
                        height,
                        viewportHeight *
                          1.4
                      );

                    const topPenalty =
                      Math.max(
                        0,
                        documentTop
                      ) *
                      80;

                    const selectorBonus =
                      (
                        selectors.length -
                        selectorIndex
                      ) *
                      8000;

                    const idealHeight =
                      viewportHeight *
                      0.75;

                    const heightPenalty =
                      Math.abs(
                        Math.min(
                          height,
                          viewportHeight *
                            2
                        ) -
                        idealHeight
                      ) *
                      120;

                    const score =
                      area +
                      selectorBonus -
                      topPenalty -
                      heightPenalty;

                    candidates.push({
                      element,
                      score
                    });
                  }
                );
            }
          );

          candidates.sort(
            (a, b) =>
              b.score -
              a.score
          );

          return candidates.map(
            (item) =>
              item.element
          );
        },

        findHero() {
          if (
            this.config
              .customHeroSelector
          ) {
            const custom =
              this.safeQuerySelector(
                this.config
                  .customHeroSelector
              );

            if (custom) {
              return custom;
            }
          }

          return (
            this.heroCandidates()[0] ||
            null
          );
        },

        resolveHero(
          force = false
        ) {
          if (
            this.config
              .triggerMode !==
            'smart'
          ) {
            return;
          }

          if (
            !force &&

            this.hero &&

            this.hero.isConnected
          ) {
            return;
          }

          const nextHero =
            this.findHero();

          if (nextHero) {
            this.heroSearchExhausted =
              false;

            this.setHero(
              nextHero
            );

            return;
          }

          this.hero =
            null;

          if (
            this.heroObserver
          ) {
            this.heroObserver
              .disconnect();

            this.heroObserver =
              null;
          }

          this.scheduleHeroLookup();
        },

        scheduleHeroLookup() {
          if (
            this.heroLookupTimer
          ) {
            return;
          }

          if (
            this.heroLookupAttempts >=
            20
          ) {
            this.heroSearchExhausted =
              true;

            this.requestUpdate();

            return;
          }

          this.heroLookupAttempts +=
            1;

          this.heroLookupTimer =
            window.setTimeout(
              () => {
                this.heroLookupTimer =
                  null;

                this.resolveHero(
                  true
                );

                this.requestUpdate();
              },
              250
            );
        },

        setHero(
          element
        ) {
          if (
            this.hero ===
            element
          ) {
            return;
          }

          this.hero =
            element;

          this.heroLookupAttempts =
            0;

          this.heroSearchExhausted =
            false;

          if (
            this.heroLookupTimer
          ) {
            window.clearTimeout(
              this.heroLookupTimer
            );

            this.heroLookupTimer =
              null;
          }

          if (
            this.heroObserver
          ) {
            this.heroObserver
              .disconnect();

            this.heroObserver =
              null;
          }

          this.resolvePageScrollElement(
            true
          );

          if (
            'IntersectionObserver'
            in window
          ) {
            let observerRoot =
              null;

            if (
              this.pageScrollElement &&

              this.pageScrollElement
                .contains(
                  element
                )
            ) {
              observerRoot =
                this.pageScrollElement;
            }

            this.heroObserver =
              new IntersectionObserver(
                () => {
                  this.requestUpdate();
                },

                {
                  root:
                    observerRoot,

                  threshold: [
                    0,
                    0.05,
                    0.1,
                    0.15,
                    0.2,
                    0.25,
                    0.5,
                    0.75,
                    1
                  ]
                }
              );

            this.heroObserver
              .observe(
                element
              );
          }
        },

        getHeroRevealState() {
          if (
            !this.hero ||
            !this.hero.isConnected
          ) {
            return null;
          }

          const rect =
            this.hero
              .getBoundingClientRect();

          if (
            rect.width <= 0 ||
            rect.height <= 0
          ) {
            return null;
          }

          let viewportTop =
            0;

          let viewportHeight =
            Math.max(
              1,

              window.innerHeight ||

              document.documentElement
                .clientHeight ||

              1
            );

          if (
            this.pageScrollElement &&

            this.pageScrollElement
              .isConnected &&

            this.pageScrollElement
              .contains(
                this.hero
              )
          ) {
            const rootRect =
              this.pageScrollElement
                .getBoundingClientRect();

            viewportTop =
              rootRect.top;

            viewportHeight =
              Math.max(
                1,

                this.pageScrollElement
                  .clientHeight ||

                rootRect.height ||

                viewportHeight
              );
          }

          const relativeTop =
            rect.top -
            viewportTop;

          const relativeBottom =
            rect.bottom -
            viewportTop;

          const visiblePercent =
            this.config
              .heroVisiblePercent /
            100;

          const normalTravel =
            rect.height *
            (
              1 -
              visiblePercent
            );

          const cappedTravel =
            viewportHeight *
            0.7;

          const requiredTravel =
            Math.max(
              120,

              Math.min(
                normalTravel,
                cappedTravel
              )
            );

          if (
            relativeBottom <=
            0
          ) {
            return true;
          }

          return (
            relativeTop <=
            -requiredTravel
          );
        },

        getRawRevealState() {
          if (
            this.config.forceShow
          ) {
            return true;
          }

          if (
            this.config
              .triggerMode ===
            'smart'
          ) {
            if (
              !this.hero ||
              !this.hero.isConnected
            ) {
              this.resolveHero();
            }

            const heroState =
              this.getHeroRevealState();

            if (
              heroState !==
              null
            ) {
              return heroState;
            }

            if (
              !this.heroSearchExhausted
            ) {
              return false;
            }
          }

          return (
            this.getCurrentScrollTop() >=
            this.getFallbackThreshold()
          );
        },

        shouldShow() {
          /*
           * 用户关闭优先。
           */
          if (
            this.dismissed
          ) {
            return false;
          }

          if (
            this.config.forceShow
          ) {
            return true;
          }

          if (
            !this.config
              .hideWhenBackAtTop &&

            this.everRevealed
          ) {
            return true;
          }

          return (
            this.getRawRevealState()
          );
        },

        requestUpdate() {
          if (
            this.frameRequested
          ) {
            return;
          }

          this.frameRequested =
            true;

          this.animationFrame =
            window
              .requestAnimationFrame(
                () => {
                  this.frameRequested =
                    false;

                  this.update();
                }
              );
        },

        update() {
          const rawRevealState =
            this.getRawRevealState();

          /*
           * 如果不记住关闭状态，
           * 回到隐藏区域以后允许再次出现。
           */
          if (
            this.dismissed &&

            !this.config
              .rememberDismiss &&

            !rawRevealState
          ) {
            this.dismissed =
              false;
          }

          if (
            this.shouldShow()
          ) {
            this.scheduleReveal();

            return;
          }

          this.cancelReveal();

          if (
            this.config
              .hideWhenBackAtTop ||

            !this.everRevealed
          ) {
            this.setVisible(
              false
            );
          }
        },

        scheduleReveal() {
          if (
            this.isVisible
          ) {
            return;
          }

          if (
            this.revealTimer
          ) {
            return;
          }

          const reveal =
            () => {
              this.revealTimer =
                null;

              if (
                !this.shouldShow()
              ) {
                return;
              }

              this.ensureFloating();

              this.everRevealed =
                true;

              this.setVisible(
                true
              );
            };

          if (
            this.config.forceShow ||

            this.config.delay <=
              0
          ) {
            reveal();

            return;
          }

          this.revealTimer =
            window.setTimeout(
              reveal,
              this.config.delay
            );
        },

        cancelReveal() {
          if (
            !this.revealTimer
          ) {
            return;
          }

          window.clearTimeout(
            this.revealTimer
          );

          this.revealTimer =
            null;
        },

        /*
         * ================================
         * Floating player
         * ================================
         */

        applyFloatingStyles(
          element
        ) {
          const ratio =
            manager.normalizeRatio(
              this.config.ratio
            );

          const widths =
            manager.getPresetWidths(
              this.config
                .desktopSizePreset,

              this.config
                .mobileSizePreset,

              this.config.ratio
            );

          element.style
            .setProperty(
              '--fv-aspect-ratio',
              ratio.css
            );

          element.style
            .setProperty(
              '--fv-desktop-width',
              `${widths.desktop}px`
            );

          element.style
            .setProperty(
              '--fv-mobile-width',
              `${widths.mobile}px`
            );

          element.style
            .setProperty(
              '--fv-desktop-side',
              `${this.config.desktopSideOffset}px`
            );

          element.style
            .setProperty(
              '--fv-mobile-side',
              `${this.config.mobileSideOffset}px`
            );

          element.style
            .setProperty(
              '--fv-radius',
              `${this.config.borderRadius}px`
            );

          element.classList
            .add(
              `fv-position-${this.config.desktopHorizontalPosition}`,

              `fv-mobile-position-${this.config.mobileHorizontalPosition}`,

              ratio.className
            );

          if (
            this.config.showShadow
          ) {
            element.classList
              .add(
                'fv-has-shadow'
              );
          }
        },

        updateFloatingGeometry() {
          if (
            !this.floating ||
            !this.floating.isConnected
          ) {
            return;
          }

          const currentMode =
            this.positionStorageMode();

          /*
           * Desktop / Mobile
           * 分别保存自己的拖动坐标。
           */
          if (
            this.positionMode !==
            currentMode
          ) {
            if (
              this.restoreUserPositionForCurrentMode()
            ) {
              return;
            }
          } else if (
            this.hasUserPosition &&
            this.userPosition
          ) {
            /*
             * Resize / 横竖屏后重新限制边界。
             */
            this.applyUserPosition(
              this.userPosition
                .left,

              this.userPosition
                .top,

              false
            );

            return;
          } else {
            const saved =
              this.readUserPosition(
                currentMode
              );

            if (saved) {
              this.applyUserPosition(
                saved.left,
                saved.top,
                false
              );

              return;
            }
          }

          /*
           * 没有用户拖动坐标：
           * 按后台默认位置显示。
           */
          const viewportHeight =
            Math.max(
              1,

              window.innerHeight ||

              document.documentElement
                .clientHeight ||

              1
            );

          const boxHeight =
            Math.max(
              1,

              this.floating
                .getBoundingClientRect()
                .height
            );

          const percent =
            this.isMobile()
              ? this.config
                  .mobileVerticalPercent
              : this.config
                  .desktopVerticalPercent;

          const safeBottom =
            8;

          const safeTop =
            8;

          const requestedBottom =
            viewportHeight *
            (
              percent /
              100
            );

          const maximumBottom =
            Math.max(
              safeBottom,

              viewportHeight -
              boxHeight -
              safeTop
            );

          const bottom =
            Math.min(
              maximumBottom,

              Math.max(
                safeBottom,
                requestedBottom
              )
            );

          this.floating
            .style
            .setProperty(
              '--fv-vertical-offset',

              `${Math.round(
                bottom
              )}px`
            );
        },

        ensureFloating() {
          if (
            this.floating
              ?.isConnected
          ) {
            this.updateFloatingGeometry();

            return;
          }

          /*
           * 小窗口永远 Shopify Video。
           */
          const media =
            manager.createFloatingVideo(
              this.config
            );

          const floating =
            document.createElement(
              'div'
            );

          floating.className =
            'fv-floating';

          floating.dataset
            .fvInstance =
            this.sectionId;

          floating.setAttribute(
            'aria-hidden',
            'true'
          );

          this.applyFloatingStyles(
            floating
          );

          const mediaWrap =
            document.createElement(
              'div'
            );

          mediaWrap.className =
            'fv-floating-media';

          mediaWrap.appendChild(
            media
          );

          /*
           * 全屏透明点击层。
           */
          const openButton =
            document.createElement(
              'button'
            );

          openButton.className =
            'fv-open-button';

          openButton.type =
            'button';

          openButton.tabIndex =
            -1;

          openButton.setAttribute(
            'aria-label',
            'Open product video'
          );

          openButton.addEventListener(
            'click',
            (event) => {
              /*
               * 刚刚完成拖动：
               * 吃掉这一次 click。
               */
              if (
                this.suppressOpenClick
              ) {
                event.preventDefault();

                event.stopPropagation();

                this.suppressOpenClick =
                  false;

                if (
                  this.suppressOpenClickTimer
                ) {
                  window.clearTimeout(
                    this.suppressOpenClickTimer
                  );

                  this.suppressOpenClickTimer =
                    null;
                }

                return;
              }

              /*
               * 普通点击：
               * 打开放大播放器。
               */
              this.openModal();
            }
          );

          /*
           * ×
           */
          const closeButton =
            document.createElement(
              'button'
            );

          closeButton.className =
            'fv-close';

          closeButton.type =
            'button';

          closeButton.tabIndex =
            -1;

          closeButton.setAttribute(
            'aria-label',
            'Close floating video'
          );

          closeButton.innerHTML =
            '<span aria-hidden="true">×</span>';

          closeButton.addEventListener(
            'click',
            (event) => {
              event.preventDefault();

              event.stopPropagation();

              this.dismiss();
            }
          );

          floating.append(
            mediaWrap,
            openButton
          );

          /*
           * Badge
           */
          if (
            this.config.showBadge &&
            this.config.badgeText
          ) {
            const badge =
              document.createElement(
                'div'
              );

            badge.className =
              'fv-badge';

            badge.setAttribute(
              'aria-hidden',
              'true'
            );

            const badgeIcon =
              document.createElement(
                'span'
              );

            badgeIcon.className =
              'fv-badge-icon';

            const badgeText =
              document.createElement(
                'span'
              );

            badgeText.textContent =
              this.config
                .badgeText;

            badge.append(
              badgeIcon,
              badgeText
            );

            floating.appendChild(
              badge
            );
          }

          floating.appendChild(
            closeButton
          );

          /*
           * 防止 Theme transform /
           * overflow 影响 fixed。
           */
          document.body.appendChild(
            floating
          );

          this.floating =
            floating;

          this.floatingMedia =
            media;

          this.openButton =
            openButton;

          this.closeButton =
            closeButton;

          this.installFloatingDrag(
            floating
          );

          this.syncFocusableState();

          window.requestAnimationFrame(
            () => {
              this.updateFloatingGeometry();
            }
          );
        },

        syncFocusableState() {
          const tabIndex =
            this.isVisible
              ? 0
              : -1;

          if (
            this.openButton
          ) {
            this.openButton.tabIndex =
              tabIndex;
          }

          if (
            this.closeButton
          ) {
            this.closeButton.tabIndex =
              tabIndex;
          }
        },

        playFloatingMedia() {
          if (
            !(
              this.floatingMedia instanceof
              HTMLVideoElement
            )
          ) {
            return;
          }

          this.floatingMedia
            .play()
            .catch(
              () => {}
            );
        },

        pauseFloatingMedia() {
          if (
            !(
              this.floatingMedia instanceof
              HTMLVideoElement
            )
          ) {
            return;
          }

          this.floatingMedia
            .pause();
        },

        setVisible(
          visible
        ) {
          if (visible) {
            this.ensureFloating();

            this.updateFloatingGeometry();
          }

          if (
            !this.floating
          ) {
            this.isVisible =
              false;

            return;
          }

          if (
            visible ===
            this.isVisible
          ) {
            if (visible) {
              this.playFloatingMedia();
            }

            return;
          }

          this.isVisible =
            visible;

          this.floating
            .classList
            .toggle(
              'is-visible',
              visible
            );

          this.floating
            .setAttribute(
              'aria-hidden',
              visible
                ? 'false'
                : 'true'
            );

          this.syncFocusableState();

          if (visible) {
            this.playFloatingMedia();
          } else {
            this.pauseFloatingMedia();
          }
        },

        dismiss() {
          this.dismissed =
            true;

          this.saveDismissedState();

          this.cancelReveal();

          this.setVisible(
            false
          );
        },

        /*
         * ================================
         * Modal
         * ================================
         */

        getModalMedia() {
          /*
           * 优先 YouTube。
           *
           * 只有 URL 合法并能提取 ID，
           * 才真的使用 YouTube。
           */
          if (
            this.config.youtubeUrl
          ) {
            const youtubeMedia =
              manager.createYouTubeModal(
                this.config.youtubeUrl
              );

            if (youtubeMedia) {
              return {
                media:
                  youtubeMedia,

                usesYouTube:
                  true
              };
            }
          }

          /*
           * 没填 YouTube 或 URL 无效：
           * 自动回退 Shopify。
           */
          return {
            media:
              manager.createShopifyModalVideo(
                this.config
              ),

            usesYouTube:
              false
          };
        },

        openModal() {
          if (
            !this.floating
          ) {
            return;
          }

          this.closeModal(
            true
          );

          const result =
            this.getModalMedia();

          const media =
            result.media;

          if (!media) {
            return;
          }

          this.modalUsesYouTube =
            result.usesYouTube;

          const modal =
            document.createElement(
              'div'
            );

          modal.className =
            'fv-modal';

          modal.dataset
            .fvModal =
            this.sectionId;

          modal.setAttribute(
            'role',
            'dialog'
          );

          modal.setAttribute(
            'aria-modal',
            'true'
          );

          modal.setAttribute(
            'aria-label',
            'Product video'
          );

          const ratio =
            manager.normalizeRatio(
              this.config.ratio
            );

          const content =
            document.createElement(
              'div'
            );

          content.className =
            `fv-modal-content ${ratio.className}`;

          content.style
            .setProperty(
              '--fv-aspect-ratio',
              ratio.css
            );

          const closeButton =
            document.createElement(
              'button'
            );

          closeButton.className =
            'fv-modal-close';

          closeButton.type =
            'button';

          closeButton.setAttribute(
            'aria-label',
            'Close product video'
          );

          closeButton.innerHTML =
            '<span aria-hidden="true">×</span>';

          closeButton.addEventListener(
            'click',
            () => {
              this.closeModal();
            }
          );

          modal.addEventListener(
            'click',
            (event) => {
              if (
                event.target ===
                modal
              ) {
                this.closeModal();
              }
            }
          );

          this.onModalKeydownBound =
            (event) => {
              if (
                event.key ===
                'Escape'
              ) {
                this.closeModal();

                return;
              }

              /*
               * Modal 中目前只有 Close
               * 需要键盘焦点约束。
               */
              if (
                event.key ===
                  'Tab' &&

                this.modalCloseButton
              ) {
                event.preventDefault();

                this.modalCloseButton
                  .focus();
              }
            };

          document.addEventListener(
            'keydown',
            this.onModalKeydownBound
          );

          content.appendChild(
            media
          );

          modal.append(
            content,
            closeButton
          );

          this.lastFocusedElement =
            document.activeElement;

          document.body.appendChild(
            modal
          );

          this.modal =
            modal;

          this.modalMedia =
            media;

          this.modalCloseButton =
            closeButton;

          /*
           * 如果没有 YouTube：
           * 大窗是同一个 Shopify 视频，
           * 从小窗当前时间继续。
           */
          if (
            !this.modalUsesYouTube &&

            media instanceof
              HTMLVideoElement &&

            this.floatingMedia instanceof
              HTMLVideoElement
          ) {
            try {
              media.currentTime =
                this.floatingMedia
                  .currentTime || 0;
            } catch (error) {
              /*
               * Ignore seek error.
               */
            }
          }

          /*
           * 大窗口出现以后
           * 暂停背景小窗口。
           */
          this.pauseFloatingMedia();

          document.body
            .classList
            .add(
              'fv-modal-open'
            );

          requestAnimationFrame(
            () => {
              modal.classList
                .add(
                  'is-open'
                );
            }
          );

          /*
           * Shopify Modal：
           * 用户主动点击触发，
           * 尝试有声播放。
           */
          if (
            !this.modalUsesYouTube &&

            media instanceof
              HTMLVideoElement
          ) {
            media.muted =
              false;

            media.defaultMuted =
              false;

            media.volume =
              1;

            media
              .play()
              .catch(
                () => {}
              );
          }

          window.setTimeout(
            () => {
              closeButton.focus({
                preventScroll:
                  true
              });
            },
            0
          );
        },

        closeModal(
          immediate = false
        ) {
          if (
            !this.modal
          ) {
            return;
          }

          const modal =
            this.modal;

          const modalMedia =
            this.modalMedia;

          const lastFocusedElement =
            this.lastFocusedElement;

          const wasYouTube =
            this.modalUsesYouTube;

          if (
            this.onModalKeydownBound
          ) {
            document.removeEventListener(
              'keydown',
              this.onModalKeydownBound
            );

            this.onModalKeydownBound =
              null;
          }

          /*
           * Shopify 大窗：
           * 关闭时把播放时间同步回小窗。
           *
           * YouTube 不同步。
           */
          if (
            !wasYouTube &&

            modalMedia instanceof
              HTMLVideoElement &&

            this.floatingMedia instanceof
              HTMLVideoElement
          ) {
            try {
              this.floatingMedia
                .currentTime =
                modalMedia
                  .currentTime || 0;
            } catch (error) {
              /*
               * Ignore.
               */
            }
          }

          if (
            modalMedia instanceof
            HTMLVideoElement
          ) {
            modalMedia.pause();
          }

          if (
            modalMedia instanceof
            HTMLIFrameElement
          ) {
            manager.youtubeCommand(
              modalMedia,
              'pauseVideo'
            );
          }

          modal.classList
            .remove(
              'is-open'
            );

          const remove =
            () => {
              modal.remove();

              if (
                !document.querySelector(
                  '.fv-modal'
                )
              ) {
                document.body
                  .classList
                  .remove(
                    'fv-modal-open'
                  );
              }
            };

          if (immediate) {
            remove();
          } else {
            window.setTimeout(
              remove,
              190
            );
          }

          this.modal =
            null;

          this.modalMedia =
            null;

          this.modalCloseButton =
            null;

          this.modalUsesYouTube =
            false;

          this.lastFocusedElement =
            null;

          /*
           * 大窗口关闭后：
           * 如果浮窗仍显示，则继续播放。
           */
          if (
            this.isVisible
          ) {
            this.playFloatingMedia();
          }

          if (
            !immediate &&

            lastFocusedElement &&

            typeof
              lastFocusedElement
                .focus ===
              'function'
          ) {
            window.setTimeout(
              () => {
                try {
                  lastFocusedElement
                    .focus({
                      preventScroll:
                        true
                    });
                } catch (error) {
                  /*
                   * Ignore.
                   */
                }
              },
              0
            );
          }
        },

        refreshHero() {
          if (
            this.config
              .triggerMode !==
            'smart'
          ) {
            return;
          }

          this.heroLookupAttempts =
            0;

          this.heroSearchExhausted =
            false;

          this.resolvePageScrollElement(
            true
          );

          this.resolveHero(
            true
          );

          this.requestUpdate();
        }
      };
    },

    /*
     * ================================
     * Shopify Theme Editor
     * ================================
     */

    installEditorListeners() {
      if (
        this.listenersInstalled
      ) {
        return;
      }

      this.listenersInstalled =
        true;

      document.addEventListener(
        'shopify:section:load',
        (event) => {
          const root =
            event.target
              ?.matches?.(
                '[data-fv-root]'
              )
              ? event.target
              : event.target
                  ?.querySelector?.(
                    '[data-fv-root]'
                  );

          if (root) {
            this.init(
              root
            );
          }
        }
      );

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          const sectionId =
            String(
              event.detail
                ?.sectionId || ''
            ).trim();

          const instance =
            this.instances.get(
              sectionId
            );

          if (instance) {
            instance.destroy();

            this.instances.delete(
              sectionId
            );
          }
        }
      );

      document.addEventListener(
        'shopify:section:select',
        (event) => {
          const sectionId =
            String(
              event.detail
                ?.sectionId || ''
            ).trim();

          const instance =
            this.instances.get(
              sectionId
            );

          if (!instance) {
            return;
          }

          instance.refreshHero();

          instance.requestUpdate();
        }
      );

      document.addEventListener(
        'shopify:section:deselect',
        (event) => {
          const sectionId =
            String(
              event.detail
                ?.sectionId || ''
            ).trim();

          const instance =
            this.instances.get(
              sectionId
            );

          if (!instance) {
            return;
          }

          instance.requestUpdate();
        }
      );

      document.addEventListener(
        'shopify:block:select',
        () => {
          for (
            const instance
            of this.instances.values()
          ) {
            instance.refreshHero();
          }
        }
      );
    }
  };

  window[GLOBAL_KEY] =
    manager;

  manager.installEditorListeners();

  const boot =
    () => {
      manager.scan(
        document
      );
    };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      {
        once: true
      }
    );
  } else {
    boot();
  }
})();